var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormula(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.691 397.242H35.31C15.809 397.242 0 381.434 0 361.93V35.309C0 15.809 15.809 0 35.309 0H432.55c19.504 0 35.312 15.809 35.312 35.309v195.71zm0 0",
    fill: "#b0d3f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 88.277v52.965h-79.45V96.31a8.481 8.481 0 018.829-8.032zm0 0",
    fill: "#ff5364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.723 96.309v44.933H123.586V88.277h291.312a8.48 8.48 0 018.825 8.032zm0 0",
    fill: "#e6e7e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 141.242h300.137v52.965H123.586zm0 0",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 194.207h300.137v52.965H123.586zm0 0",
    fill: "#e6e7e8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 247.172h300.137v52.965H123.586zm0 0",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 300.137h300.137v52.965H123.586zm0 0",
    fill: "#e6e7e8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 300.137v52.965H52.965a8.481 8.481 0 01-8.828-8.032v-44.933zm0 0",
    fill: "#ff5364"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.137 141.242h79.449v52.965h-79.45zm0 0",
    fill: "#fb7b76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.137 194.207h79.449v52.965h-79.45zm0 0",
    fill: "#ff5364"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.137 247.172h79.449v52.965h-79.45zm0 0",
    fill: "#fb7b76"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.621 52.965H52.965a8.829 8.829 0 010-17.656H70.62a8.829 8.829 0 010 17.656zm0 0",
    fill: "#c03a2b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.586 52.965H105.93a8.829 8.829 0 010-17.656h17.656a8.829 8.829 0 010 17.656zm0 0",
    fill: "#f0c419"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.207 52.965h-35.309c-4.878 0-8.828-3.953-8.828-8.828s3.95-8.828 8.828-8.828h35.309a8.829 8.829 0 010 17.656zm0 0",
    fill: "#24ae5f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M423.723 52.965H229.516c-4.875 0-8.825-3.953-8.825-8.828s3.95-8.828 8.825-8.828h194.207a8.829 8.829 0 010 17.656zm0 0",
    fill: "#2c2f38"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M229.516 211.863h264.828c9.75 0 17.656 7.903 17.656 17.653v264.828c0 9.75-7.906 17.656-17.656 17.656H229.516c-9.75 0-17.653-7.906-17.653-17.656V229.516c0-9.75 7.903-17.653 17.653-17.653zm0 0",
    fill: "#24ae5f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#71c285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.656 485.516c-19.504 0-35.312-15.809-35.312-35.309a8.829 8.829 0 0117.656 0c0 9.75 7.906 17.656 17.656 17.656s17.653-7.906 17.653-17.656l17.699-177.434c.87-19.027 16.672-33.937 35.719-33.699 19.043.239 34.468 15.54 34.859 34.582a8.829 8.829 0 01-17.656 0c0-9.75-7.903-17.656-17.653-17.656-9.754 0-17.656 7.906-17.656 17.656l-17.7 177.434c-.37 19.183-16.077 34.52-35.265 34.426zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.102 361.93h-79.446a8.826 8.826 0 01-8.828-8.828c0-4.875 3.953-8.825 8.828-8.825h79.446a8.823 8.823 0 018.828 8.825 8.824 8.824 0 01-8.828 8.828zm0 0M450.207 476.691a8.85 8.85 0 01-6.242-2.59l-79.45-79.445c-3.343-3.465-3.296-8.972.11-12.375a8.828 8.828 0 0112.375-.11l79.45 79.45a8.822 8.822 0 011.91 9.617 8.826 8.826 0 01-8.153 5.453zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.758 476.691a8.83 8.83 0 01-6.242-15.07l79.449-79.45a8.828 8.828 0 0112.375.11c3.406 3.403 3.453 8.91.11 12.375L377 474.102a8.842 8.842 0 01-6.242 2.59zm0 0"
  }))));
}

export default __webpack_public_path__ + "9755309ccbd8d9eeb79f01367148ae5a.svg";
export { SvgFormula as ReactComponent };